"use strict";
/**
 * CrudeAppComponents extrahiert das template aus dem appLayout
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var FilterAlt_1 = __importDefault(require("@mui/icons-material/FilterAlt"));
var SearchComponent_1 = __importDefault(require("../shared/components/CrudeComponents/SearchComponent"));
var FilterComponent_1 = __importDefault(require("../shared/components/CrudeComponents/FilterComponent"));
var AddButtonComponent_1 = __importDefault(require("../shared/components/CrudeComponents/AddButtonComponent"));
var TabComponent_1 = __importDefault(require("../shared/components/CrudeComponents/TabComponent"));
var commonTypes_1 = require("../shared/types/commonTypes");
var EntitySelect_1 = __importDefault(require("./EntitySelect"));
var crude_selector_1 = require("../store/crude/crude.selector");
var react_router_1 = require("react-router");
var ResponsiveTabComponent_1 = __importDefault(require("./DataResponsiveView/ResponsiveTabComponent"));
var ButtonComponent_1 = __importDefault(require("../shared/components/FormComponents/ButtonComponent"));
var DialogComponent_1 = __importDefault(require("../shared/components/MessageComponents/DialogComponent"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/styles");
var crudeActions = __importStar(require("../store/crude/crude.actions"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    filterButton: {
        '& .MuiButton-startIcon': {
            marginLeft: 0,
            marginRight: 0,
        },
        '& .MuiButton-root': {
            borderColor: theme.palette.primary.main,
            border: '1px solid',
            minWidth: '48px',
            '&.Mui-disabled ': {
                borderColor: theme.palette.grey.A200,
            },
        },
    },
}); });
var CrudeAppComponents = function () {
    var history = react_router_1.useHistory();
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var displayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var crudeTabs = react_redux_1.useSelector(crude_selector_1.getCrudeTabs);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudePath = react_redux_1.useSelector(crude_selector_1.getCrudePath) || '';
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var activeEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var _a = react_1.useState([]), crudeAppElements = _a[0], setCrudeAppElements = _a[1];
    var createNewEntity = function (selectedEntity) {
        var newPath = crudePath + "/" + selectedEntity + "/new";
        history.push(newPath);
    };
    // Template Snippets
    var AddIconTemplate = function () {
        return (react_1.default.createElement(react_router_dom_1.Switch, null, crudeTabs && crudeTabs.map(function (tab) {
            var entitySchema = crudeSchema &&
                crudeSchema.find(function (schema) { return schema.name === tab.entity; });
            return (react_1.default.createElement(react_router_dom_1.Route, { key: tab.entity, path: crudePath + "/" + tab.entity + "/:id?" },
                react_1.default.createElement(AddButtonComponent_1.default, { display: true, disabled: !(entitySchema && entitySchema.entityPermissions.createAllowed), onClick: function (entity) { return createNewEntity(entity); } })));
        })));
    };
    var SearchTemplate = function () {
        return (react_1.default.createElement(react_router_dom_1.Switch, null, crudeTabs && crudeTabs.map(function (tab) {
            var entitySchema = crudeSchema &&
                crudeSchema.find(function (schema) { return schema.name === tab.entity; });
            return (react_1.default.createElement(react_router_dom_1.Route, { key: tab.entity, path: crudePath + "/" + tab.entity + "/:id?" },
                react_1.default.createElement(SearchComponent_1.default, { treeviewLevel: 0, entity: tab.entity, disabled: !(entitySchema && entitySchema.isSearchable), fullWidth: true })));
        })));
    };
    var setCrudeTemplate = function () {
        var elements = [];
        var columns = 12;
        var lines = 0;
        // prüfen, wieviele lines nötig sind
        appLayout.elements.map(function (element) {
            if (lines < element.position.vertical.to) {
                lines = element.position.vertical.to;
            }
        });
        var _loop_1 = function (l) {
            var _loop_2 = function (c) {
                var existingAppElement = null;
                appLayout.elements.map(function (element) {
                    if (c === element.position.horizontal.from && l === element.position.vertical.from) {
                        existingAppElement = element;
                    }
                });
                if (existingAppElement) {
                    var appElement = existingAppElement;
                    switch (appElement.id) {
                        case 'search':
                            elements.push(react_1.default.createElement(material_1.Grid, { container: true, item: true, rowSpacing: 2, key: "line" + l + "-column" + c, xs: (appElement.position.horizontal.to - appElement.position.horizontal.from + 1), sx: { mb: 3 }, alignItems: appElement.alignItems, justifyContent: appElement.justifyContent }, displayMode === commonTypes_1.DataDisplayMode.list && SearchTemplate()));
                            break;
                        case 'filter':
                            elements.push(react_1.default.createElement(material_1.Grid, { item: true, key: "line" + l + "-column" + c, xs: (appElement.position.horizontal.to - appElement.position.horizontal.from + 1), sx: { mb: 3 }, alignItems: appElement.alignItems, justifyContent: appElement.justifyContent }, displayMode === commonTypes_1.DataDisplayMode.list && react_1.default.createElement(FilterComponent_1.default, { treeviewLevel: 0 })));
                            break;
                        case 'addIcon':
                            elements.push(react_1.default.createElement(material_1.Grid, { key: "line" + l + "-column" + c, item: true, xs: (appElement.position.horizontal.to - appElement.position.horizontal.from + 1), sx: { mb: 3 }, alignItems: appElement.alignItems, justifyContent: appElement.justifyContent }, displayMode === commonTypes_1.DataDisplayMode.list && AddIconTemplate()));
                            break;
                        case 'tabs':
                            elements.push(react_1.default.createElement(material_1.Grid, { key: "line" + l + "-column" + c, item: true, xs: (appElement.position.horizontal.to - appElement.position.horizontal.from + 1), alignItems: appElement.alignItems, justifyContent: appElement.justifyContent },
                                react_1.default.createElement(TabComponent_1.default, null)));
                            break;
                    }
                    c += (appElement.position.horizontal.to - appElement.position.horizontal.from);
                }
                else {
                    elements.push(react_1.default.createElement(material_1.Grid, { item: true, xs: 1, key: "line" + l + "-column" + c }));
                }
                out_c_1 = c;
            };
            var out_c_1;
            for (var c = 0; c < columns; c += 1) {
                _loop_2(c);
                c = out_c_1;
            }
        };
        for (var l = 0; l <= lines; l += 1) {
            _loop_1(l);
        }
        setCrudeAppElements(elements);
    };
    react_1.useEffect(function () {
        appLayout && crudeLabels && crudeTabs && setCrudeTemplate();
    }, [crudeLabels, appLayout, crudeTabs, displayMode]);
    var _b = react_1.useState(false), showFilter = _b[0], setShowFilter = _b[1];
    var _c = react_1.useState(), tempFilter = _c[0], setTempFilter = _c[1];
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 1 },
        screenDesign !== commonTypes_1.ScreenDesign.mobile &&
            react_1.default.createElement(react_1.default.Fragment, null, crudeAppElements && crudeAppElements.map(function (component) { return (component); })),
        screenDesign === commonTypes_1.ScreenDesign.mobile &&
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, sx: { margin: theme.spacing(1) + " 0 " + theme.spacing(2) + " 0" } },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 9 }, SearchTemplate()),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'right' },
                    react_1.default.createElement(material_1.Box, { style: { textAlign: 'right' }, className: classes.filterButton },
                        react_1.default.createElement(ButtonComponent_1.default, { disabled: dataDisplayMode !== commonTypes_1.DataDisplayMode.list, onClick: function () { return setShowFilter(true); }, color: 'primary', variant: 'text', startIcon: react_1.default.createElement(FilterAlt_1.default, null) })),
                    react_1.default.createElement(DialogComponent_1.default, { title: react_1.default.createElement(react_1.default.Fragment, null, t('crude:filter')), content: react_1.default.createElement(material_1.Box, { sx: { marginTop: theme.spacing(2) } },
                            react_1.default.createElement(FilterComponent_1.default, { treeviewLevel: 0, onChangeFilter: function (filter) { return setTempFilter(filter); } })), request: true, open: showFilter, onClose: function () { return setShowFilter(false); }, confirmLabel: t('crude:useFilter'), cancelLabel: t('crude:defaultFilter'), autoClose: false, onConfirm: function () {
                            tempFilter && dispatch(crudeActions.setTableFilterSettings(tempFilter));
                            setShowFilter(false);
                        }, onCancel: function () {
                            var _a;
                            if (activeEntity) {
                                var changeSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[activeEntity] = __assign(__assign({}, storedTableFilterSettings[activeEntity]), { 0: __assign(__assign({}, storedTableFilterSettings[activeEntity][0]), { page: 0, filter: {} }) }), _a));
                                dispatch(crudeActions.setTableFilterSettings(changeSettings));
                            }
                            setShowFilter(false);
                        } })),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 9 },
                    react_1.default.createElement(ResponsiveTabComponent_1.default, null)),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'right' }, AddIconTemplate())),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: { paddingTop: '0 !important' } },
            react_1.default.createElement(react_router_dom_1.Switch, null, crudeTabs && crudeTabs.map(function (tab) {
                return (react_1.default.createElement(react_router_dom_1.Route, { key: tab.entity, path: crudePath + "/" + tab.entity + "/:id?" },
                    react_1.default.createElement(EntitySelect_1.default, { entity: tab.entity })));
            })))));
};
exports.default = CrudeAppComponents;
